import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import CustomHeader from "common/component/Header/CustomHeader";
import UrlMigrationBanner from "common/component/UrlMigrationBanner/UrlMigrationBanner";
import Paths from "../common/paths/paths";

/**
 * Components use for the different pages
 */
import LocalITHardwareRestock from "views/LocalITHardwareRestock";
import LocalITOrderConfirmation from "views/LocalITOrderConfirmation";
import LocalITOrderList from "views/LocalITOrderList";

const RoutesConfiguration = () => (
    <BrowserRouter>
        <CustomHeader />
        <UrlMigrationBanner />
        <Routes>
            <Route path={Paths.itOrderList.url} element={<LocalITOrderList />} />
            <Route path={Paths.itHardwareRestock.url} element={<LocalITHardwareRestock />} />
            <Route path={Paths.itOrderConfirmation.url} element={<LocalITOrderConfirmation />} />
            <Route path="*" element={<Navigate to={Paths.defaultPagePath} replace />} />
        </Routes>
    </BrowserRouter>
);

export default RoutesConfiguration;
